export default "__VITE_PUBLIC_ASSET__fd2cf2c3__"